import React, { useState, useRef, useEffect } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

const TEAL = "#06b6a4";

const FILTER_OPTIONS = ["Fund", "Category"];

const FUNDS_LIST = [
  "Abakkus Mutual Fund",
  "Aditya Birla Sun Life Mutual Fund",
  "Axis Mutual Fund",
  "HDFC Mutual Fund",
  "ICICI Prudential Mutual Fund",
];

const CATEGORIES_LIST = [
  "Debt: Banking and PSU",
  "Debt: Corporate Bond",
  "Equity: Large Cap",
  "Hybrid: Balanced Advantage",
];



const TABLE_HEADERS = [
  { key: "ucc", label: "UCC", sort: false, search: true },
  { key: "investor", label: "Investor", sort: true, search: true },
  { key: "scheme", label: "Scheme", sort: true, search: false },
  { key: "folio", label: "Folio", sort: false, search: true },
  { key: "category", label: "Category", sort: false, search: true },
  { key: "currentValue", label: "Current Value (₹)", sort: true, search: false, highlight: true },
  { key: "actions", label: "Actions", sort: false, search: false },
];

const inputStyle = {
  borderRadius: "8px",
  border: "1px solid #cbd5e1",
  padding: "8px 12px",
  fontSize: "14px",
  width: "100%",
  background: "#fff",
};

export default function AdditionalTransaction() {
  const [searchText, setSearchText] = useState("");
  const [filterType, setFilterType] = useState("Fund");
  const [filterValue, setFilterValue] = useState("");
  const [activeFoliosOnly, setActiveFoliosOnly] = useState(true);
  const [activeFilters, setActiveFilters] = useState([
    { type: "Category", value: "Debt: Banking and PSU" },
    { type: "Fund", value: "Abakkus Mutual Fund" },
  ]);
  const [filterDropdownOpen, setFilterDropdownOpen] = useState(false);
  const [valueDropdownOpen, setValueDropdownOpen] = useState(false);
  const filterDropdownRef = useRef(null);
  const valueDropdownRef = useRef(null);

  const optionsByFilterType = {
    Fund: FUNDS_LIST,
    Category: CATEGORIES_LIST,
   
  };
  const valueOptions = optionsByFilterType[filterType] || [];
  const valueLabel = filterType === "Fund" ? "Funds" : filterType === "Category" ? "Category" : "Scheme";

  useEffect(() => {
    function handleClickOutside(e) {
      if (filterDropdownRef.current && !filterDropdownRef.current.contains(e.target)) {
        setFilterDropdownOpen(false);
      }
      if (valueDropdownRef.current && !valueDropdownRef.current.contains(e.target)) {
        setValueDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const addFilter = (value) => {
    const val = value !== undefined ? value : filterValue;
    if (!val) return;
    if (activeFilters.some((f) => f.type === filterType && f.value === val)) return;
    setActiveFilters((prev) => [...prev, { type: filterType, value: val }]);
    setFilterValue("");
    setValueDropdownOpen(false);
  };

  const removeFilter = (index) => {
    setActiveFilters((prev) => prev.filter((_, i) => i !== index));
  };

  const clearAllFilters = () => {
    setActiveFilters([]);
  };

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9", minHeight: "100vh" }}>
        {/* Header */}
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
          <div className="card-body p-4">
            <h3 className="text-primary mb-2">Additional Transaction</h3>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <NavLink to="/overview">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <span style={{ color: "#64748b" }}>Invest Online BSE</span> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">Additional Transaction</li>
              </ol>
            </nav>
          </div>
        </div>

        {/* Top filters */}
        <div className="card shadow-sm border-0 mb-3" style={{ borderRadius: "12px", border: "1px solid #e2e8f0", overflow: "visible" }}>
          <div className="card-body p-4" style={{ overflow: "visible" }}>
            <div className="row g-3 align-items-end flex-wrap" style={{ overflow: "visible" }}>
              {/* Search */}
              <div className="col-12 col-md-3">
                <label className="form-label small text-muted mb-1">Search</label>
                <div className="position-relative d-flex align-items-center" style={inputStyle}>
                  <input
                    type="text"
                    className="form-control border-0 shadow-none p-0 bg-transparent"
                    placeholder="Search..."
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    style={{ flex: 1, outline: "none" }}
                  />
                  {searchText && (
                    <button
                      type="button"
                      className="btn btn-link p-0 border-0"
                      style={{ color: "#64748b", minWidth: 24 }}
                      onClick={() => setSearchText("")}
                      aria-label="Clear search"
                    >
                    
                    </button>
                  )}
                </div>
              </div>
              {/* Filter type */}
              <div className="col-12 col-md-2" ref={filterDropdownRef} style={{ overflow: "visible" }}>
                <label className="form-label small text-muted mb-1">Filter</label>
                <div style={{ position: "relative", overflow: "visible" }}>
                  <div
                    role="button"
                    tabIndex={0}
                    onClick={() => setFilterDropdownOpen(!filterDropdownOpen)}
                    onKeyDown={(e) => e.key === "Enter" && setFilterDropdownOpen(!filterDropdownOpen)}
                    style={{ ...inputStyle, display: "flex", alignItems: "center", cursor: "pointer" }}
                  >
                    <i className="fa fa-filter px-2" style={{ color: "#64748b" }} aria-hidden />
                    <span className="flex-grow-1" style={{ color: "#334155" }}>{filterType}</span>
                    <i className={`fa fa-chevron-${filterDropdownOpen ? "up" : "down"} px-2`} style={{ color: "#64748b" }} aria-hidden />
                  </div>
                  {filterDropdownOpen && (
                    <div
                      onMouseDown={(e) => e.stopPropagation()}
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        marginTop: 4,
                        background: "#fff",
                        border: "1px solid #e2e8f0",
                        borderRadius: "8px",
                        boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                        zIndex: 1050,
                        overflow: "hidden",
                      }}
                    >
                      {FILTER_OPTIONS.map((opt) => (
                        <div
                          key={opt}
                          role="button"
                          tabIndex={0}
                          onClick={() => { setFilterType(opt); setFilterDropdownOpen(false); setFilterValue(""); }}
                          onKeyDown={(e) => e.key === "Enter" && (setFilterType(opt), setFilterDropdownOpen(false), setFilterValue(""))}
                          style={{ padding: "10px 12px", cursor: "pointer", fontSize: "14px", color: "#334155" }}
                          className="additional-tx-filter-item"
                        >
                          {opt}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              {/* Funds / Category / Scheme value */}
              <div className="col-12 col-md-3" ref={valueDropdownRef} style={{ overflow: "visible" }}>
                <label className="form-label small text-muted mb-1">{valueLabel}</label>
                <div style={{ position: "relative", overflow: "visible" }}>
                  <div
                    role="button"
                    tabIndex={0}
                    onClick={() => setValueDropdownOpen(!valueDropdownOpen)}
                    onKeyDown={(e) => e.key === "Enter" && setValueDropdownOpen(!valueDropdownOpen)}
                    style={{ ...inputStyle, display: "flex", alignItems: "center", cursor: "pointer" }}
                  >
                    <i className="fa fa-filter px-2" style={{ color: "#64748b" }} aria-hidden />
                    <span className="flex-grow-1" style={{ color: filterValue ? "#334155" : "#94a3b8" }}>
                      {filterValue || `Select ${valueLabel}`}
                    </span>
                    <i className={`fa fa-chevron-${valueDropdownOpen ? "up" : "down"} px-2`} style={{ color: "#64748b" }} aria-hidden />
                  </div>
                  {valueDropdownOpen && (
                    <div
                      onMouseDown={(e) => e.stopPropagation()}
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        marginTop: 4,
                        background: "#fff",
                        border: "1px solid #e2e8f0",
                        borderRadius: "8px",
                        boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                        zIndex: 1050,
                        maxHeight: 220,
                        overflowY: "auto",
                      }}
                    >
                      {valueOptions.map((opt) => (
                        <div
                          key={opt}
                          role="button"
                          tabIndex={0}
                          onClick={() => addFilter(opt)}
                          onKeyDown={(e) => e.key === "Enter" && addFilter(opt)}
                          style={{ padding: "10px 12px", cursor: "pointer", fontSize: "14px", color: "#334155" }}
                          className="additional-tx-filter-item"
                        >
                          {opt}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              {/* Folio toggle */}
              <div className="col-12 col-md-4 d-flex align-items-center justify-content-md-end gap-2">
                <span className="small text-muted">Active Folios</span>
                <button
                  type="button"
                  role="switch"
                  aria-checked={activeFoliosOnly}
                  onClick={() => setActiveFoliosOnly(!activeFoliosOnly)}
                  style={{
                    width: 44,
                    height: 24,
                    borderRadius: 12,
                    border: "none",
                    background: activeFoliosOnly ? TEAL : "#cbd5e1",
                    position: "relative",
                    cursor: "pointer",
                    transition: "background 0.2s",
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      top: 2,
                      left: activeFoliosOnly ? 22 : 2,
                      width: 20,
                      height: 20,
                      borderRadius: "50%",
                      background: "#fff",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                      transition: "left 0.2s",
                    }}
                  />
                </button>
                <span className="small text-muted">All Folios</span>
              </div>
            </div>
          </div>
    

        {/* Active filters chips */}
        {activeFilters.length > 0 && (
            <div className="card-body py-3 px-4">
              <div className="d-flex flex-wrap align-items-center gap-2">
                {activeFilters.map((f, index) => (
                  <span
                    key={`${f.type}-${f.value}-${index}`}
                    className="d-inline-flex align-items-center gap-1 px-3 py-1 rounded-pill"
                    style={{ background: "#f1f5f9", fontSize: "13px", color: "#475569" }}
                  >
                    {f.type}: {f.value}
                    <button
                      type="button"
                      className="btn btn-link p-0 border-0"
                      style={{ color: "", minWidth: 20 }}
                      onClick={() => removeFilter(index)}
                      aria-label={`Remove ${f.type} filter`}
                    >
                      <i className="fa fa-times" style={{ fontSize: "12px" }} aria-hidden />
                    </button>
                  </span>
                ))}
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1"
                  onClick={clearAllFilters}
                >
                  <i className="fa fa-times" aria-hidden /> Clear All
                </button>
              </div>
            </div>
       
        )}

        {/* Table */}
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead style={{ background: "#f8fafc" }}>
                <tr>
                  {TABLE_HEADERS.map((h) => (
                    <th
                      key={h.key}
                      style={{
                        padding: "12px 16px",
                        color: h.highlight ? TEAL : "#475569",
                        fontWeight: "600",
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                        borderLeft: h.highlight ? `2px solid ${TEAL}` : undefined,
                        borderRight: h.highlight ? `2px solid ${TEAL}` : undefined,
                        background: h.highlight ? "rgba(6, 182, 164, 0.08)" : undefined,
                      }}
                    >
                      {h.label}
                      {h.sort && <i className="fa fa-sort ms-1 opacity-75" style={{ fontSize: "10px" }} aria-hidden />}
                      {h.search && <i className="fa fa-search ms-1 opacity-75" style={{ fontSize: "10px" }} aria-hidden />}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody style={{ background: "#fff", minHeight: 200 }}>
                <tr>
                  <td colSpan={7} className="text-center py-5">
                    <div className="d-flex flex-column align-items-center justify-content-center text-muted">
                      <i className="fa fa-exclamation-triangle mb-2" style={{ fontSize: "28px", color: "#f59e0b" }} aria-hidden />
                      <span style={{ fontSize: "15px" }}>No data available.</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <style>{`
        .additional-tx-filter-item:hover { background: #ecfdf5 !important; color: #0d9488 !important; }
      `}</style>
    </>
  );
}
